<template>
    <div v-if="enableDivider" class="green-divider bg-primary-light"></div>
    <div :class="['px-3 py-4 justify-space-between align-center', className]">
        <div class="text-size-md">{{ t('travelCard.cardNumber') }}</div>
        <div data-id="travelCardNumber" class="card-number text-size-xl line-height-1 font-weight-regular letter-spacing-1">
            {{ travelCardNumber }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { ITicketCard } from '@/features/TravelCards/types';

const { t } = useI18n();

defineProps<ITicketCard>();
</script>
